import Icon from '../components/Icon.vue'

Icon.register({"user":{"width":448,"height":512,"paths":[{"d":"M224 256C294.7 256 352 198.7 352 128S294.7 0 224 0 96 57.3 96 128 153.3 256 224 256zM313.6 288H296.9C274.7 298.2 250 304 224 304S173.4 298.2 151.1 288H134.4C60.2 288 0 348.2 0 422.4V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V422.4C448 348.2 387.8 288 313.6 288z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user.js
// module id = 15Ef
// module chunks = 0